import validate from "/home/ivan/Dev/projects/BB/bigbang.ba/node_modules/nuxt/dist/pages/runtime/validate.js";
import app_45global from "/home/ivan/Dev/projects/BB/nuxt-base/middleware/app.global.js";
import guards_45global from "/home/ivan/Dev/projects/BB/nuxt-base/middleware/guards.global.js";
import redirect_45global from "/home/ivan/Dev/projects/BB/nuxt-base/middleware/redirect.global.js";
import _00_45cmsstaticcontent_45routing_45global from "/home/ivan/Dev/projects/BB/bigbang-base/middleware/00.cmsstaticcontent-routing.global.js";
import _00_45search_45query_45global from "/home/ivan/Dev/projects/BB/bigbang-base/middleware/00.search-query.global.js";
import auth_45return_45global from "/home/ivan/Dev/projects/BB/bigbang-base/middleware/auth-return.global.js";
import copy_45cart_45global from "/home/ivan/Dev/projects/BB/bigbang-base/middleware/copy-cart.global.js";
import oms_45global from "/home/ivan/Dev/projects/BB/bigbang-base/middleware/oms.global.js";
import redirects_45global from "/home/ivan/Dev/projects/BB/bigbang-base/middleware/redirects.global.js";
import zz_45cmsstaticcontent_45preview_45global from "/home/ivan/Dev/projects/BB/bigbang-base/middleware/zz.cmsstaticcontent-preview.global.js";
import manifest_45route_45rule from "/home/ivan/Dev/projects/BB/bigbang.ba/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  app_45global,
  guards_45global,
  redirect_45global,
  _00_45cmsstaticcontent_45routing_45global,
  _00_45search_45query_45global,
  auth_45return_45global,
  copy_45cart_45global,
  oms_45global,
  redirects_45global,
  zz_45cmsstaticcontent_45preview_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}